import { Routes, Route } from "react-router-dom";
import List from "./List";
import Show from "./Show";

const AccountHealthSnapshotsMspa = (): JSX.Element => (
  <Routes>
    <Route path="/" element={<List />} />
    <Route path="/:slug" element={<Show />} />
  </Routes>
);

export default AccountHealthSnapshotsMspa;
